import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import queryString from 'query-string';
import Navbar from 'components/NavOnScroll';
import Session from 'components/SessionReplica';
import Footer from 'components/MiniFooter';
import renderIf from 'render-if';
// import { logoutUser } from 'components/Session/Session.actions';
import { logPageView, initGA } from 'utils/analytics';
import { regExForName, regExForEmail } from 'constants/Regularexpression'; // regular expressions to validate user input
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import Modal from 'react-modal';
import SchoolSearchComponent from 'components/CoachRegistration';
import Sendgrid from 'components/SendGrid';

import styles from './Contact.scss';
// to import local scss fle

const modalStyle = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

class Contact extends Component {
  static propTypes = {
    sendContactForm: PropTypes.func.isRequired,
    location: PropTypes.shape().isRequired,
    attributes: PropTypes.shape().isRequired,
    logoutUser: PropTypes.func.isRequired,
    history: PropTypes.shape(),
  };
  static defaultProps = {
    history: {
      push: () => {},
    },
  }
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      firstName: '',
      lastName: '',
      email: '',
      division: '',
      message: '',
      questionLink: '',
      teamPageLink: '',
      college_id: '',
      invalidFirstName: false,
      invalidLastName: false,
      invalidEmail: false,
      invalidMessage: false,
      open: false,
      invalidCollege: false,
      invalidState: false,
      invalidCity: false,
      renderCoachForm: false,
      city: '',
      state: '',
      college: '',
    };
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeFocus = this.handleChangeFocus.bind(this);
    this.sendMail = this.sendMail.bind(this);
    this.logOutUser = this.logOutUser.bind(this);
    this.getDataForCoach = this.getDataForCoach.bind(this);
  }
  componentWillMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    if (query && Object.prototype.hasOwnProperty.call(query, 'coach_add_application')) {
      if (this.props.attributes.size > 0) {
        this.props.attributes.get('username');
      }
      this.setState({ renderCoachForm: true });
    }
  }

  componentDidMount() {
    initGA();
        logPageView(this.props.match.path); // eslint-disable-line
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.attributes.size > 0) {
      const fullName = nextProps.attributes.get('name');
      const parts = fullName.split(' ');
      const firstName = parts.shift();
      const lastName = parts.shift() || '';
      const newState = {
        email: nextProps.attributes.get('email'),
        firstName,
        lastName,
      };
      this.setState(newState);
    }
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  getDataForCoach(value) {
    const newState = {
      city: value.city,
      division: value.division,
      questionLink: value.questionLink,
      state: value.state,
      teamPageLink: value.teamPageUrl,
      college: value.value,
      college_id: value.id,
    };
    this.setState(newState);
  }
  logOutUser() {
    this.onCloseModal();
    this.props.logoutUser();
    this.props.history.push('/');
  }
  handleChange(name, value) {
    this.setState({ ...this.state, [name]: value.target.value });
  }

  handleChangeFocus(name) {
    this.setState({ ...this.state, [name]: false });
  }
  sendMail() {
    const { firstName, lastName, email, message, college, city, division,
        state, renderCoachForm, college_id, questionLink, teamPageLink } = this.state;
    const updated = {};
    let validFirstName = false;
    let validLastName = false;
    let validEmail = false;
    let validMessage = false;
    let validCollege = true;
    let validCity = true;
    let validState = true;

    const enteredName = regExForName.test(firstName);
    if (firstName !== '' && enteredName) {
      validFirstName = true;
    } else {
      updated.invalidFirstName = true;
    }

    const enteredLastName = regExForName.test(lastName);
    if (lastName === '') {
      validLastName = true;
    } else if (enteredLastName) {
      updated.invalidLastName = false;
      validLastName = true;
    } else {
      updated.invalidLastName = true;
    }

    const enteredEmail = regExForEmail.test(email);
    if (email !== '' && enteredEmail) {
      validEmail = true;
    } else {
      updated.invalidEmail = true;
    }

    if (message !== '') {
      validMessage = true;
    } else if (this.state.renderCoachForm) {
      validMessage = true;
    } else {
      updated.invalidMessage = true;
    }


    if (college === '' && renderCoachForm) {
      validCollege = false;
      updated.invalidCollege = true;
    }

    if (city === '' && renderCoachForm) {
      validCity = false;
      updated.invalidCity = true;
    }
    if (state === '' && renderCoachForm) {
      validState = false;
      updated.invalidState = true;
    }
    if (validFirstName && validLastName && validEmail && validMessage && validCollege
         && validCity && validState) {
      let payload = {};
      if (!renderCoachForm) {
        payload = Object.assign(payload, {
          firstname: firstName,
          lastname: lastName,
          email,
          message,
        });
      }
      if (this.state.renderCoachForm) {
        payload = Object.assign(payload, {
          fullname: `${firstName} ${lastName}`,
          email,
          college,
          city,
          state,
          sport: 'FOOTBALL',
        });
        /* eslint-disable */
        if (college_id !== '') {
          payload['college_id'] = college_id;
          payload['division'] = division;
          payload['question_link'] = questionLink;
          payload['team_page_link'] = teamPageLink;
        }
        /* eslint-disable */
      }
      this.setState({ firstName: '', lastName: '', email: '', message: '', college: '', state: '', city: '' });
      console.log(payload, renderCoachForm);
      this.props.sendContactForm(payload, renderCoachForm);
      this.onOpenModal();
    } else {
      this.setState(updated);
    }
  };

  writeCollegeName = (value) => {
    this.setState({ college: value });
  };

  handleCloseModal = () => {
    if(this.state.renderCoachForm){
      this.logOutUser();
    }else {
      this.onCloseModal();
    }
  };

  render() {
    const { invalidFirstName, invalidLastName, invalidEmail, invalidMessage, open,
     invalidCollege, invalidCity, invalidState } = this.state;
    const renderCoachForm = renderIf(this.state.renderCoachForm);
    const renderMessageBox = renderIf(!this.state.renderCoachForm);
    return (
      <div className={cn('row', styles.container)}>
        <Modal style={modalStyle} isOpen={open} >
          We will get back to you soon. Keep Exploring!
          <button className={styles.okbuttonModal} onClick={this.handleCloseModal} >OK</button>
        </Modal>
        <div className={cn('col s12', styles.navbarContainer)}>
          <Navbar {...this.props} />
        </div>
        <div className={cn('col s12', styles.contactContainer)}>
          <div className={cn('col s6', styles.address)}>
            <div className={styles.gotQuestionOrQur}>
                            Got Questions or Queries?<br />
                            Type your needed request and we’ll <br /> fnd you a solution.
                        </div>
            <div className={styles.header}>
                            MyRecruitBoard
                        </div>
            <div className={styles.headerText}>
              <span>
                Email: info@myrecruitboard.com
              </span>
            </div>
          </div>
          <div className={cn('col s12 m6', styles.contactInSmall)}>
            <div className={cn('col s12', styles.removePadding)}>
              <div className={styles.bigHeader}>
                How can we assist you?
            </div>
              <div className={styles.formHeader}>
                 Fill out this form to contact us if you have any further questions
                </div>
            </div>
            <div className={cn('col s12', styles.formContainer)} >
              <div className={invalidFirstName === false ? cn('col s6', styles.halfInput) : cn('col s6', styles.halfInputOnError)}>
                <input
                  value={this.state.firstName}
                  onChange={val => this.handleChange('firstName', val)}
                  onFocus={() => this.handleChangeFocus('invalidFirstName')}
                  placeholder="FirstName"
                />
              </div>
              <div className={invalidLastName === false ? cn('col s6', styles.secondHalfInput) : cn('col s6', styles.secondHalfInputOnError)}>
                <input
                  value={this.state.lastName}
                  onChange={val => this.handleChange('lastName', val)}
                  onFocus={() => this.handleChangeFocus('invalidLastName')}
                  placeholder="LastName"
                />
              </div>
              {renderMessageBox(
                <div className={invalidEmail === false ? cn('col s12', styles.fullInput) : cn('col s12', styles.fullInputOnError)}>
                  <input
                    value={this.state.email}
                    onChange={val => this.handleChange('email', val)}
                    onFocus={() => this.handleChangeFocus('invalidEmail')}
                    placeholder="Email"
                  />
                </div>,
                )}
              {renderCoachForm(
                <div className={invalidEmail === false ? cn('col s12', styles.fullInput) : cn('col s12', styles.fullInputOnError)}>
                  <input
                    value={this.state.email}
                    onChange={val => this.handleChange('email', val)}
                    onFocus={() => this.handleChangeFocus('invalidEmail')}
                    placeholder="Email"
                    disabled="disabled"
                  />
                </div>,
                )}
              {renderCoachForm(
                <div>
                  <div className={invalidCollege === false ? cn('col s12', styles.fullInput) : cn('col s12', styles.fullInputOnError)}>
                    <SchoolSearchComponent
                      usedFor="contact"
                      getDataForCoach={this.getDataForCoach}
                      writeCollegeName={this.writeCollegeName}
                    />
                  </div>
                  <div className={invalidState === false ? cn('col s6', styles.halfInput) : cn('col s6', styles.halfInputOnError)}>
                    <input
                      value={this.state.state}
                      onChange={val => this.handleChange('state', val)}
                      onFocus={() => this.handleChangeFocus('invaidState')}
                      placeholder="City"
                    />
                  </div>
                  <div className={invalidCity === false ? cn('col s6', styles.secondHalfInput) : cn('col s6', styles.secondHalfInputOnError)}>
                    <input
                      value={this.state.city}
                      onChange={val => this.handleChange('city', val)}
                      onFocus={() => this.handleChangeFocus('invalidCity')}
                      placeholder="State"
                    />
                  </div>
                </div>,
                )}
              {renderMessageBox(
                <div className={invalidMessage === false ? cn('col s12', styles.messageContainer) : cn('col s12', styles.messageContainerOnError)}>
                  <textarea
                    value={this.state.message}
                    onChange={val => this.handleChange('message', val)}
                    onFocus={() => this.handleChangeFocus('invalidMessage')}
                    placeholder="Message"
                  />
                </div>,
                )}
            </div>
            <div className={cn('col s12', styles.buttonContainer)}>
              <button className={styles.submitButton} onClick={this.sendMail}>Submit</button>
            </div>
            <div className={cn('col s12', styles.addressInSmall)}>
              <div className={styles.gotQuestionOrQur}>
                Got Questions or Queries?<br />
                Type your needed request and we’ll fnd you a solution.
            </div>
              <div className={styles.header}>
                MyRecruitBoard
            </div>
              <div className={styles.headerText}>
                <span>
                    Email: info@myrecruitboard.com
                  </span>
              </div>
            </div>
          </div>
        </div>
        <div className={cn('col s12', styles.footerContainer)}>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Session(Sendgrid(Contact));



// WEBPACK FOOTER //
// ./src/containers/Contact/Contact.js